import React from 'react'
import {Glyphicon, Tabs, Tab} from 'react-bootstrap'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, setUserSettings, setSessionKeyValue, getSessionKeyValue} from '../../storage'
import {NotificationManager} from 'react-notifications'
import _ from 'lodash'
import Select from 'react-select';
class Settings extends React.Component {

  constructor(){
    super()
    this.state = {loading:true, selected_users:[], activeTabKey:1}
    this.getSettings = this.getSettings.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSettingsOptionChange = this.handleSettingsOptionChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.addSeries = this.addSeries.bind(this)
    this.deleteInvoiceSeries = this.deleteInvoiceSeries.bind(this)
    document.title = "Edit Settings"
  }
  handleTabSelect = (key)=>{
    this.setState({'activeTabKey': key})
    setSessionKeyValue('activeTabKey', key)
  }

  handleUserChange = (phone)=> {
    let currentSelectedUsers = this.state.selected_users || []
    currentSelectedUsers.push(phone)
    this.setState({selected_users: currentSelectedUsers})
  }
  removeFromSelectedUsers= (phone)=>{
    let selected_users = this.state.selected_users.filter((pne)=> pne !== phone)
    this.setState({selected_users: selected_users})
  }
  updateUsers = (e)=> {
    this.setState({updating:true})
    e.preventDefault()
    axios({
      url: '/update_company_team_members/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state
    }).then((response)=> {
      if(response.status === 200) {
        this.setState({updating:false})

        NotificationManager.success("Team updated successfully")

      }
    }).catch((err)=> {
      this.setState({updating:false})

    })
  }

  getUsers =(input)=> {

    return   axios({
        url: '/list_users/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.users}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}

getTeam = ()=>{
   axios({
      url: '/get_company_team/',
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
          this.setState({'selected_users': response.data.team})
    }).catch((err)=> {


    })
}

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let currentItem = this.state.settings
        currentItem[name] = value
        this.setState({
          settings: currentItem
       });
  }

  handleSettingsOptionChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let settings = this.state.settings
    let currentOptions = settings.options
    if(typeof currentOptions !== "undefined" && currentOptions !== null) {
      currentOptions[name] = value
    }
    else {
      currentOptions= {}
      currentOptions[name] = value
    }
    settings['options'] = currentOptions
    this.setState({
          settings: settings
     });
  }

  handleSubmit(event) {
    this.setState({updating:true})
    event.preventDefault()
    if(event.target.name === 'createGstForm' || event.target.name === "createUnitForm"){
      return false
    }

    axios({
      url: '/update_settings/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.settings
    }).then((response)=> {
      if(response.status === 200) {
        const settings = response.data.settings
        setUserSettings(settings)
        this.setState({updating:false})
        NotificationManager.success("Settings updated successfully")
      }
    }).catch((err)=> {
      this.setState({updating:false})
    })
  }

  deleteInvoiceSeries(e, series_id) {
    this.setState({updating:true})
    e.preventDefault()
    axios({
      url: '/delete_invoice_series/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: {"series_id": series_id}
    }).then((response)=> {
      if(response.status === 200) {
        this.setState({updating:false})
        this.getSettings().then((response)=>{
          if(response.status===200) {
            this.setState({loading:false, settings: response.data.settings, invoiceseries: response.data.invoiceseries})
          }
        }).catch((err)=>{
          if(typeof err.response === "undefined") {
                this.setState({loading_error: 'Could not connect to server', loading:false})
          }
          else {
              this.setState({loading_error: err.response.statusText, loading:false})
          }
        })
        NotificationManager.success("Removed Series successfully")
      }
    }).catch((err)=> {
      this.setState({updating:false})
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        let error_response_data = err.response.data.error
        if(typeof error_response_data !== "undefined") {
          NotificationManager.error(error_response_data)
        }
      }
    })
  }

  addToSettingsOptionsList = (optionListName, value) => {

    let settings = this.state.settings
    let currentOptions = settings.options
    let optionValueList
    if(typeof currentOptions !== "undefined" && currentOptions !== null) {

    }
    else {
      currentOptions= {}

    }

    if(currentOptions[optionListName] && Array.isArray(currentOptions[optionListName])) {
       optionValueList = currentOptions[optionListName]
      optionValueList.push(value)
    }
    else {
      optionValueList = []
      optionValueList.push(value)
    }
    currentOptions[optionListName] = optionValueList

    settings['options'] = currentOptions
    this.setState({
          settings: settings
     });
  }

  removeFromSettingsOptionsList = (optionListName, key) => {


    let settings = this.state.settings
    let currentOptions = settings.options


    let existingOptionList = currentOptions[optionListName]

    existingOptionList = existingOptionList.filter(param => param !== key)

    currentOptions[optionListName] = existingOptionList

    settings['options'] = currentOptions
    this.setState({
          settings: settings
     });
  }


  addSeries(e) {
    this.setState({updating:true})
    e.preventDefault()
    axios({
      url: '/create_invoice_series/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.settings
    }).then((response)=> {
      if(response.status === 200) {
        this.setState({updating:false})
        this.getSettings().then((response)=>{
          if(response.status===200) {

            this.setState({loading:false, settings: response.data.settings, invoiceseries: response.data.invoiceseries})
          }
        }).catch((err)=>{
          if(typeof err.response === "undefined") {
                this.setState({loading_error: 'Could not connect to server', loading:false})
          }
          else {
              this.setState({loading_error: err.response.statusText, loading:false})
          }
        })

        NotificationManager.success("Series added successfully")
      }
    }).catch((err)=> {
      this.setState({updating:false})
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        let error_response_data = err.response.data.error
        if(typeof error_response_data !== "undefined") {
          NotificationManager.error(error_response_data)
        }
      }
    })
  }

  componentDidMount() {
    this.getSettings().then((response)=>{
      if(response.status===200) {

        this.setState({loading:false, settings: response.data.settings, invoiceseries: response.data.invoiceseries})
      }
    }).catch((err)=>{
      if(typeof err.response === "undefined") {
            this.setState({loading_error: 'Could not connect to server', loading:false})
      }
      else {
          this.setState({loading_error: err.response.statusText, loading:false})
      }
    })

    this.getTeam();
    let tabKey = getSessionKeyValue('activeTabKey')

    if(tabKey) {
      this.setState({activeTabKey: parseInt(tabKey)})
    }
  }

  getSettings() {
    return axios({
      url: '/get_settings/',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  render() {

    let invoiceSettingsForm, purchaseSettingsForm, itemSettingsForm, creditSettingsForm, tableSettingsForm, clientSettingsForm, usersForm

    let submitButton = <input type="submit" className="btn btn-success" value="save"  />
    let addSeries, add_additional_client_param
    if(this.state.updating) {
      submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
      addSeries = <button className="btn btn-sm btn-success" disabled>Add Series</button>
    }
    else {
      addSeries = <button className="btn btn-sm btn-success" onClick={this.addSeries}>Add Series</button>
    }

    if(!this.state.loading && typeof this.state.loading_error !== "undefined") {
      invoiceSettingsForm = this.state.loading_error
    }
    else if(!this.state.loading){

      let settings = this.state.settings
      let options = settings.options ? settings.options : {}
      let invoiceSeries = this.state.invoiceseries
      let invoiceSeriesArray = [  ]
      if(typeof invoiceSeries !== "undefined" && invoiceSeries.length > 0) {

        invoiceSeriesArray = _.map( invoiceSeries, series =>{

          const item = <li key={series.id}  className="psmall"><button className="btn btn-info btn-sm" onClick={(e)=>{this.deleteInvoiceSeries(e, series.id)}}>
            {series.series_name} <Glyphicon glyph="remove" />
          </button>

          </li>

          return item
        })
        invoiceSeriesArray = <ul className="list-inline">{invoiceSeriesArray}</ul>
      }
      else {
        invoiceSeriesArray = "None"
      }


      let form_exp_date

      if(settings.item_track_batches) {
        form_exp_date = <div className="form-group">
          <label className="col-sm-4 col-md-3">Show Exp Date </label>
            <div className="col-sm-6">
              <input type="checkbox" name="show_invoice_expiry_date" checked={settings.show_invoice_expiry_date} onChange={this.handleInputChange} />
              Applicable only for item entry in batch mode.
            </div>
        </div>
      }


      let invoice_additional_params, invoice_item_additional_params, invoice_additional_charges

      if(options.invoice_additional_params && options.invoice_additional_params.length) {

        invoice_additional_params = options.invoice_additional_params.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('invoice_additional_params', param)}}>
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }
      if(options.invoice_additional_charges && options.invoice_additional_charges.length) {

        invoice_additional_charges = options.invoice_additional_charges.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('invoice_additional_charges', param)}} >
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }
      if(options.invoice_item_additional_params && options.invoice_item_additional_params.length) {
        invoice_item_additional_params = options.invoice_item_additional_params.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('invoice_item_additional_params', param)}}>
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }

      invoiceSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal ">

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Invoice Label</label>
            <div className="col-sm-2">
              <input className="form-control" type="text" name="invoice_label" value={settings.invoice_label} onChange={this.handleInputChange} />
            </div>

        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Enable Purchase Order For Invoice ?</label>
          <div className="col-sm-6">
            <input type="checkbox" name="enable_invoice_purchase_order" checked={options.enable_invoice_purchase_order} onChange={this.handleSettingsOptionChange} />
          </div>
        </div>



        <div className="form-group hidden">
          <label className="col-sm-4 col-md-3">Enable Invoice Additional Params</label>
          <div className="col-sm-6">
            <input type="checkbox" name="enable_invoice_additional_params" checked={settings.enable_invoice_additional_params} onChange={this.handleInputChange} />
            <span className="text-warning small">Deprecated -- <span className="text-muted">Use Additional Params instead.</span></span>

          </div>
        </div>





        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Parameters for Invoice</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{invoice_additional_params}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="invoice_additional_params" ref="invoice_additional_params" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('invoice_additional_params', this.refs.invoice_additional_params.value)
                     }
                   }} />

                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();

                      this.addToSettingsOptionsList('invoice_additional_params', this.refs.invoice_additional_params.value)}}>Add Param</button>

                </div>
                <div className="col-xs-12">
                  <div className="text-muted small">Options require template support.</div>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Charges for Invoice</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{invoice_additional_charges}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="invoice_additional_charges" ref="invoice_additional_charges" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('invoice_additional_charges', this.refs.invoice_additional_charges.value)
                     }
                   }} />

                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();

                      this.addToSettingsOptionsList('invoice_additional_charges', this.refs.invoice_additional_charges.value)}}>Add Param</button>

                </div>
                <div className="col-xs-12">
                  <div className="text-muted small">Options require template support.</div>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Parameters for Invoice Item</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{invoice_item_additional_params}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="invoice_item_additional_params" ref="invoice_item_additional_params" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('invoice_item_additional_params', this.refs.invoice_item_additional_params.value)
                     }
                   }} />

                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();

                      this.addToSettingsOptionsList('invoice_item_additional_params', this.refs.invoice_item_additional_params.value)}}>Add Param</button>

                </div>
                <div className="col-xs-12">
                  <div className="text-muted small">Options require template support.</div>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Invoice Counter Padding Character and Count
            <span className="text-muted">(* Available only in default template)</span>
          </label>

            <div className="col-sm-2">
              <input className="form-control input-sm" type="text" name="counter_padding_char" value={options.counter_padding_char} onChange={this.handleSettingsOptionChange} />
            </div>
            <div className="col-sm-2">
              <select className="form-control input-sm" name="max_prefix_zeros" value={options.max_prefix_zeros} onChange={this.handleSettingsOptionChange}>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
              </select>
            </div>

        </div>


                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Invoice Terms & Conditions</label>
                    <div className="col-sm-6">
                      <input type="checkbox" name="show_invoice_tnc" checked={settings.show_invoice_tnc} onChange={this.handleInputChange} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Terms & Conditions</label>
                      <div className="col-sm-6">
                        <textarea className="form-control" onChange={this.handleInputChange} value={settings.invoice_tnc} name="invoice_tnc" disabled={!settings.show_invoice_tnc}></textarea>
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Jurisdiction Notes</label>
                      <div className="col-sm-6">
                        <input type="text" className="form-control" onChange={this.handleSettingsOptionChange}
                           value={options.jurisdiction_notes} name="jurisdiction_notes" />
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Invoice Declaration</label>
                    <div className="col-sm-6">
                      <input type="checkbox" name="show_invoice_declaration" checked={settings.show_invoice_declaration} onChange={this.handleInputChange} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Declaration</label>
                      <div className="col-sm-6">
                        <textarea className="form-control" onChange={this.handleInputChange} value={settings.invoice_declaration} name="invoice_declaration" disabled={!settings.show_invoice_declaration}></textarea>
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Bank Details on Invoice</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_bankdetails" checked={settings.show_invoice_bankdetails} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Pan Details on Invoice</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_pan" checked={settings.show_invoice_pan} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Tax Analysis</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_tax_analysis" checked={settings.show_invoice_tax_analysis} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  {form_exp_date}
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show MRP Column</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_mrp_column" checked={settings.show_invoice_mrp_column} onChange={this.handleInputChange} />
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show UOM Column</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_uom_column" checked={settings.show_invoice_uom_column} onChange={this.handleInputChange} />
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Rate with Tax Column</label>
                      <div className="col-sm-6 col-md-3">
                        <input type="checkbox" name="show_invoice_unit_rate_with_tax_col" checked={options.show_invoice_unit_rate_with_tax_col} onChange={this.handleSettingsOptionChange} />
                        <input type="text" className="form-control input-sm"
                           name="invoice_unit_rate_with_tax_col_header" defaultValue="Price" value={options.invoice_unit_rate_with_tax_col_header} onChange={this.handleSettingsOptionChange}
                           disabled={!options.show_invoice_unit_rate_with_tax_col}
                            />
                      </div>
                  </div>


                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Continer Unit Information</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_invoice_container_info" checked={settings.show_invoice_container_info} onChange={this.handleInputChange} /> Depends on UOM column
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Add Client Notes to Invoice</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="add_client_notes_to_invoice" checked={settings.add_client_notes_to_invoice} onChange={this.handleInputChange} />
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Invoice Series </label>

                      <div className="col-sm-6">
                      <div className="">
                        <div className="" style={{marginBottom:10}}>

                        Existing series {invoiceSeriesArray}
                        </div>
                        <div>
                        <div className="form-group">
                          <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                          <input type="text" className="form-control input-sm" name="series_name" value={settings.series_name} onChange={this.handleInputChange} />
                          </div>
                          <div className="col-xs-6 col-xs-6">
                          {addSeries}
                          </div>
                        </div>
                        </div>
                      </div>
                      </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Append Series Name as Suffix ?</label>
                    <div className="col-sm-6">
                      <input type="checkbox" name="append_series_name_as_suffix" checked={options.append_series_name_as_suffix} onChange={this.handleSettingsOptionChange} />
                    </div>
                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice XLS Download Format</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="invoice_xls_download_format" value={options.invoice_xls_download_format} onChange={this.handleSettingsOptionChange}>
                      <option value="default">Default</option>
                      <option value="format_b">Format B</option>
                  </select>
                  </div>
                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Entry Discounts In Percentages ?</label>

                    <div className="col-sm-6">
<input type="checkbox" name="invoice_entry_discount_mode" checked={options.invoice_entry_discount_mode} onChange={this.handleSettingsOptionChange} />
                    </div>

                  </div>


                          <div className="form-group">
                          <label className="col-sm-4 col-md-3">Invoice Entry Item Input Barcode Mode</label>
                          <div className="col-sm-6">
                          <input type="checkbox" name="invoice_entry_barcode_input" checked={options.invoice_entry_barcode_input} onChange={this.handleSettingsOptionChange} />
                          </div>
                          </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Entry Mode</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="invoice_entry_mode" value={settings.invoice_entry_mode} onChange={this.handleInputChange}>
                      <option value="default">Default</option>
                      <option value="modern">Modern</option>
                      <option value="service">Service</option>
                      <option value="fashion">Fashion Store</option>
                      <option value="mobile">Mobile Shopee</option>
                      <option value="simple_service">Simple Service</option>
                  </select>
                  </div>
                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Template Format</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="imvoice_template" value={settings.imvoice_template} onChange={this.handleInputChange}>
                      <option value="default">Default</option>
                      <option value="thin">Thin</option>
                      <option value="retail_a">Retail A</option>
                      <option value="trader_slim">Trader Slim</option>
                      <option value="trader_slim_2">Trader Slim With Logos</option>
                      <option value="trader_amigos">Trader Amigos</option>
                      <option value="trader_mill">Trader Mill</option>
                      <option value="lattice">Service Lattice</option>
                      <option value="mayer">Mayer</option>
                      <option value="cucumber">Cucumber</option>
                      <option value="mobile">Mobile Shopee</option>
                      <option value="simple_service_letter_pad">Simple Service Letter Pad</option>
                  </select>
                  </div>
                  <small className="text-primary"><i >For new invoice template, please call +91 9100433579</i> </small>
                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Style</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="invoice_style" value={settings.invoice_style} onChange={this.handleInputChange}>
                      <option value="a4p">A4 Portrait</option>
                      <option value="a4l">A4 Landscape</option>
                      <option value="a5p">A5 Portrait</option>
                      <option value="a5l">A5 Landscape</option>
                      <option value="res">Responsive</option>
                  </select>
                  </div>
                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Font Size</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="invoice_font_size" value={settings.invoice_font_size} onChange={this.handleInputChange}>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                  </select>
                  </div>

                  </div>

                  <div className="form-group">
                  <label className="col-sm-4 col-md-3">Invoice Font Family</label>
                  <div className="col-sm-2 ">
                  <select className="form-control input-sm" name="invoice_font_family" value={options.invoice_font_family} onChange={this.handleSettingsOptionChange}>
                      <option value="default">Default</option>
                      <option value="serif">Serif</option>
                      <option value="sans-serif">Sans Serif</option>
                      <option value="monospace">Monospace</option>
                  </select>
                  </div>

                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Customer&#39;s Signature Label</label>
                      <div className="col-sm-6 col-md-3">

                        <input type="text" className="form-control input-sm"
                           name="invoice_customer_sign_label" defaultValue="Customer's Signature" value={options.invoice_customer_sign_label} onChange={this.handleSettingsOptionChange}
                           />
                      </div>
                  </div>

                  <div className="form-group">
                      <label className="col-sm-4 col-md-3">Print Type Labels</label>
                        <div className="col-sm-8 ">
                          <div className="row">
                              <div className="col-sm-4">
                                Label Original
                                <input type="text" name="label_original" className="form-control input-sm" value={options.label_original} onChange={this.handleSettingsOptionChange} />
                              </div>
                              <div className="col-sm-4">
                                 Label Duplicate
                                <input type="text" name="label_duplicate" className="form-control input-sm" value={options.label_duplicate} onChange={this.handleSettingsOptionChange} />
                              </div>
                              <div className="col-sm-4">
                                Label Triplicate
                                <input type="text" name="label_triplicate" className="form-control input-sm" value={options.label_triplicate} onChange={this.handleSettingsOptionChange} />
                              </div>
                          </div>
                        </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 col-md-3"></label>
                      <div className="col-sm-6 col-md">
                        {submitButton}
                      </div>

                  </div>

      </form>


      let purchase_additional_params, purchase_additional_charges

      if(options.purchase_additional_params && options.purchase_additional_params.length) {

        purchase_additional_params = options.purchase_additional_params.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('purchase_additional_params', param)}}>
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }

      if(options.purchase_additional_charges && options.purchase_additional_charges.length) {

        purchase_additional_charges = options.purchase_additional_charges.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('purchase_additional_charges', param)}} >
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }

      purchaseSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal">

        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Params for Purchase</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{purchase_additional_params}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="purchase_additional_params" ref="purchase_additional_params" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('purchase_additional_params', this.refs.purchase_additional_params.value)
                     }
                   }} />
                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();
                      this.addToSettingsOptionsList('purchase_additional_params', this.refs.purchase_additional_params.value)}}>Add Param</button>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>


        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Charges for Purchase</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{purchase_additional_charges}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="purchase_additional_charges" ref="purchase_additional_charges" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('purchase_additional_charges', this.refs.purchase_additional_charges.value)
                     }
                   }} />

                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();

                      this.addToSettingsOptionsList('purchase_additional_charges', this.refs.purchase_additional_charges.value)}}>Add Param</button>

                </div>
                <div className="col-xs-12">
                  <div className="text-muted small">Options require template support.</div>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Enable Voucher Date for GST Reports</label>
        <div className="col-sm-4">
        <input type="checkbox" name="purchase_enable_voucher_date"
        checked={options.purchase_enable_voucher_date} onChange={this.handleSettingsOptionChange} />
        </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Purchase Entry Mode</label>
        <div className="col-sm-2 ">
        <select className="form-control input-sm" name="purchase_entry_mode" value={options.purchase_entry_mode} onChange={this.handleSettingsOptionChange}>
            <option value="default">Default</option>
            <option value="modern">Modern</option>
        </select>
        </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Auto Fill Item Purchase Rate</label>
        <div className="col-sm-4">
        <input type="checkbox" name="purchase_fill_purchaserate" checked={options.purchase_fill_purchaserate} onChange={this.handleSettingsOptionChange} />
        </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Purchase Entry Item Input Barcode Mode</label>
        <div className="col-sm-4">
        <input type="checkbox" name="purchase_entry_barcode_input" checked={options.purchase_entry_barcode_input} onChange={this.handleSettingsOptionChange} />
        </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Purchase Entry Discounts In Percentages ?</label>
          <div className="col-sm-6">
              <input type="checkbox" name="purchase_entry_discount_mode" checked={options.purchase_entry_discount_mode} onChange={this.handleSettingsOptionChange} />
          </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Purchase XLS Download Format</label>
        <div className="col-sm-2 ">
        <select className="form-control input-sm" name="purchase_xls_download_format" value={options.purchase_xls_download_format} onChange={this.handleSettingsOptionChange}>
            <option value="default">Default</option>
            <option value="format_b">Format B</option>
        </select>
        </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3"></label>
            <div className="col-sm-6 col-md">
              {submitButton}
            </div>

        </div>
      </form>



      creditSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal ">
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Credit Note Label</label>
            <div className="col-xs-6 col-sm-2">
              <input className="form-control" type="text" name="credit_label" value={settings.credit_label} onChange={this.handleInputChange} />
            </div>

        </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Credit Terms & Conditions</label>
                    <div className="col-sm-6">
                      <input type="checkbox" name="show_credit_declaration" checked={settings.show_credit_declaration} onChange={this.handleInputChange} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Terms & Conditions</label>
                      <div className="col-sm-6">
                        <textarea className="form-control" onChange={this.handleInputChange} value={settings.credit_declaration} name="credit_declaration" disabled={!settings.show_credit_declaration}></textarea>
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Bank Details on Credit Note</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_credit_bankdetails" checked={settings.show_credit_bankdetails} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Show Pan on Credit Note</label>
                      <div className="col-sm-6">
                        <input type="checkbox" name="show_credit_pan" checked={settings.show_credit_pan} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3">Credit Serial Prefix</label>
                      <div className="col-xs-6 col-sm-2">
                        <input className="form-control" type="text" name="credit_serial_prefix" value={settings.credit_serial_prefix} onChange={this.handleInputChange} />
                      </div>

                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 col-md-3"></label>
                      <div className="col-sm-6 col-md">
                        {submitButton}
                      </div>

                  </div>

      </form>


      itemSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal">

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Track Batches</label>
          <div className="col-sm-6">
            <input type="checkbox" name="item_track_batches" checked={settings.item_track_batches} onChange={this.handleInputChange} />
            <p className="">Edit this only if you know what you are doing, otherwise contact support before changing this.</p>
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Enable Auto Barcode</label>
          <div className="col-sm-6">
            <input type="checkbox" name="enable_item_barcode" checked={settings.enable_item_barcode} onChange={this.handleInputChange} />
            <p className="">Enable this if you require auto generated barcode for your items.</p>
          </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Show Brand Name in search suggestions (Modern Invoice Entry Mode)</label>
        <div className="col-sm-4">
        <input type="checkbox" name="show_brand_name_item_search_suggestions" checked={options.show_brand_name_item_search_suggestions} onChange={this.handleSettingsOptionChange} />
        </div>
        </div>

        <div className="form-group">
        <label className="col-sm-4 col-md-3">Invoice Entry Item Auto Fill Price From </label>
        <div className="col-sm-2 ">
        <select className="form-control input-sm" name="invoice_auto_fill_price" value={options.invoice_auto_fill_price} onChange={this.handleSettingsOptionChange}>
            <option value="default">Default</option>
            <option value="cpr">Closing Purchase Rate</option>
        </select>
        </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Enable Additional Barcode</label>
          <div className="col-sm-6">
            <input type="checkbox" name="enable_item_additional_barcode" checked={options.enable_item_additional_barcode} onChange={this.handleSettingsOptionChange} />
            <p className="">Enable this if you require manual entry barcode for your items.</p>
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Show Barcode Value Below (Just Barcode)</label>
          <div className="col-sm-6">
            <input type="checkbox"
             name="item_barcode_label" checked={settings.item_barcode_label} onChange={this.handleInputChange} disabled={!settings.enable_item_barcode} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Styled Barcode Text Top</label>
          <div className="col-sm-6 col-md-2">
            <input type="text"
             name="item_barcode_text_top" className="form-control input-sm" onChange={this.handleInputChange} value={settings.item_barcode_text_top} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Styled Barcode Text Bottom</label>
          <div className="col-sm-6 col-md-2">
            <input type="text"
             name="item_barcode_text_bottom" className="form-control input-sm" onChange={this.handleInputChange} value={settings.item_barcode_text_bottom} />
          </div>
        </div>
        <div className="form-group">
        <label className="col-sm-4 col-md-3">Styled Barcode Price Option</label>
        <div className="col-sm-2 ">
        <select className="form-control input-sm" name="item_barcode_price_option" value={settings.item_barcode_price_option} onChange={this.handleInputChange}>
            <option value="M">MRP</option>
            <option value="S">Selling Value</option>
        </select>
        </div>
        </div>
        <div className="form-group">
        <label className="col-sm-4 col-md-3">Styled Barcode Font Family</label>
        <div className="col-sm-2 ">
        <select className="form-control input-sm" name="item_barcode_font_family" value={settings.item_barcode_font_family} onChange={this.handleInputChange}>
            <option value="D">Default</option>
            <option value="C">Classic</option>
        </select>
        </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3">Barcode Height</label>
          <div className="col-sm-6 col-md-2">
            <input type="text" className="form-control input-sm"
             name="item_barcode_height" value={settings.item_barcode_height} onChange={this.handleInputChange}  disabled={!settings.enable_item_barcode} />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-4 col-md-3"></label>
            <div className="col-sm-6 col-md">
              {submitButton}
            </div>

        </div>
      </form>




      let client_params
      if(options.client_additional_params && options.client_additional_params.length) {
        client_params = options.client_additional_params.map((param, id)=>{
          return <li key={id}  className="">
            <button className="btn btn-info btn-sm" onClick={(e)=>{e.preventDefault();this.removeFromSettingsOptionsList('client_additional_params', param)}}>
            {param} <Glyphicon glyph="remove" />
          </button>

          </li>
        })
      }

      clientSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal">



        <div className="form-group">
            <label className="col-sm-4 col-md-3">Add Additional Params for Client</label>
            <div className="col-sm-6">
            <div className="">
              <div>
                <ul className="list-inline">{client_params}</ul>
              </div>
              <div>
              <div className="form-group">
                <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                <input type="text" className="form-control input-sm"
                   name="client_additional_params" ref="client_additional_params" onKeyDown={(e)=>{
                     if(e.key ==="Enter") {
                       e.preventDefault();
                       this.addToSettingsOptionsList('client_additional_params', this.refs.client_additional_params.value)
                     }
                   }} />
                </div>
                <div className="col-xs-6 col-xs-6">
                  <button className="btn btn-sm btn-default" onClick={(e)=>{e.preventDefault();

                      this.addToSettingsOptionsList('client_additional_params', this.refs.client_additional_params.value)}}>Add Param</button>
                </div>
              </div>
              </div>
            </div>
            </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3"></label>
            <div className="col-sm-6 col-md">
              {submitButton}
            </div>
        </div>

      </form>

      let currentSelectedUsers = this.state.selected_users
      let selectedUsersList
      if(currentSelectedUsers && currentSelectedUsers.length) {
        selectedUsersList = currentSelectedUsers.map((phone, id)=>{
          return <li key={id}><button className="btn btn-sm btn-info" onClick={(e)=>{
              e.preventDefault()
              this.removeFromSelectedUsers(phone)
            }}>{phone} <Glyphicon glyph="remove" /></button></li>
        })
      }
      usersForm = <form onSubmit={this.handleSubmit} className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4 col-md-3">Additional Team Members</label>
                  <div className="col-xs-6 col-sm-4 col-md-3 col-xs-6">
                     <ul className="list-inline">{selectedUsersList}</ul>
                    <div className="form-group">
                      <div className="col-xs-6">
                        <input type="text" className="form-control input-sm" placeholder="Enter user phone number"
                           name="client_additional_params" ref="additional_team_member_phone" onKeyDown={(e)=>{
                             if(e.key ==="Enter") {
                               e.preventDefault();
                               this.handleUserChange(this.refs.additional_team_member_phone.value)
                             }
                           }} />

                      </div>
                      <div className="col-xs-6">
                        <button onClick={(e)=>{
                            e.preventDefault()
                            this.handleUserChange(this.refs.additional_team_member_phone.value)
                          }} className="btn btn-sm btn-default">Add User</button>
                      </div>

                    </div>
                    <div className="text-muted">
                        <p className="small">Member should be a registered user at goodsbill.com</p>
                        <p className="small">Team members can login at <a target="_blank" href="https://company.goodsbill.com">https://www.company.goodsbill.com</a></p>

                    </div>
                  </div>


                </div>

                <div className="form-group">
                  <label className="col-sm-4 col-md-3"></label>
                    <div className="col-sm-6 col-md">
                      <button onClick={this.updateUsers} className="btn btn-sm btn-success">Update Team</button>
                    </div>
                </div>



      </form>



      tableSettingsForm = <form onSubmit={this.handleSubmit} className="form-horizontal">

        <div className="form-group">
            <div className="col-xs-12">
                <h4 className="text-warning">Please note that some of these ADVANCED settings will effect the application&#39;s performance.</h4>
            </div>
        </div>



        <div className="form-group">
          <label className="col-sm-4 col-md-3">Records Created & Modified Info</label>
          <div className="col-sm-6 col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">
                <input type="checkbox" name="created_and_modified_user_info" onChange={this.handleSettingsOptionChange} checked={options.created_and_modified_user_info} /> Created By & Modified By
              </div>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Additional Columns for Item List Table</label>
          <div className="col-sm-6 col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">
                <input type="checkbox" name="item_table_stock_with_tax" onChange={this.handleSettingsOptionChange} checked={options.item_table_stock_with_tax} /> Stock Value With Tax
              </div>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3">Additional Columns for Invoices List Table</label>
          <div className="col-sm-6 col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">
                <div>
                  <input type="checkbox" name="invoice_table_col_quantity" onChange={this.handleSettingsOptionChange} checked={options.invoice_table_col_quantity} /> Quantity
                </div>
                <div>
                  <input type="checkbox" name="column_invoice_profits" onChange={this.handleSettingsOptionChange} checked={options.column_invoice_profits} /> Invoice Profit
                </div>

                  <div>
                    <input type="checkbox" name="column_invoice_created" onChange={this.handleSettingsOptionChange} checked={options.column_invoice_created} /> Actual Created Date
                  </div>
                </div>
            </div>
          </div>
        </div>


        <div className="form-group">
          <label className="col-sm-4 col-md-3">Additional Columns for Purchases Table</label>
          <div className="col-sm-6 col-md-6">
            <div className="panel panel-default">
              <div className="panel-body">
                <div>
                  <input type="checkbox" name="purchase_table_col_quantity" onChange={this.handleSettingsOptionChange} checked={options.purchase_table_col_quantity} /> Quantity
                </div>
                <div>
                  <input type="checkbox" name="column_purchase_created" onChange={this.handleSettingsOptionChange} checked={options.column_purchase_created} /> Actual Created Date
                </div>


              </div>
            </div>

          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 col-md-3"></label>
            <div className="col-sm-6 col-md">
              {submitButton}
            </div>

        </div>

      </form>

    }

    console.log(typeof(this.state.activeTabKey));

    return <div>
          <section className="medium">
          <h3 className="">Settings</h3>
          </section>

          <div className="row">
            <div className="col-xs-12">

              <Tabs id="settings"  activeKey={this.state.activeTabKey}
        onSelect={this.handleTabSelect}
        >
              <Tab eventKey={1} title="Invoice Settings" >
                  <div className="panel-body">
                  {invoiceSettingsForm}
                  </div>
              </Tab>
              <Tab eventKey={2} title="Purchase Settings" >
                  <div className="panel-body">
                  {purchaseSettingsForm}
                  </div>
              </Tab>

              <Tab eventKey={3} title="Credit Note Settings" >
              <div className="panel-body">
                {creditSettingsForm}
                </div>
              </Tab>
              <Tab eventKey={4} title="Item Settings" >
              <div className="panel-body">
                {itemSettingsForm}
                </div>
              </Tab>

              <Tab eventKey={5} title="Client Settings">
                <div className="panel-body">
                  {clientSettingsForm}
                </div>
              </Tab>

              <Tab eventKey={6} title="Advanced " >
              <div className="panel-body">
                {tableSettingsForm}
                </div>
              </Tab>


              </Tabs>


            </div>
          </div>

    </div>
  }
}

export default (Settings)



// WEBPACK FOOTER //
// ./src/components/profile/editsettings.js